module.exports = __webpack_public_path__ + "img/個人檔案.16281685.svg";